import Model from '../model';

import { hashify } from '../../utils/arrays';





const ownershipNames = ['assigned', 'not_assigned', 
    'belongs_to_me', 'assigned_me', 
    'belongs_to_my_department', 'assigned_my_department', 
    'people_department', 'not_people_department', 
    'user_from_people_dep', 'user_not_from_people_dep'];
const stageNames = ['is_new', 'not_is_new', 'confirmed', 'not_confirmed'];





export default Model.extend( {

    computeds: {


        ownership: {

            deps: ['states'],

            get() {
                const dict = hashify( this.get( 'states' )
                    .map( state => state.name ) );

                const props = ownershipNames.filter( name => dict[name] );
                return props.length > 1
                    ? props.join( ', ' )
                    : props[0] || '';
            },

        },

        stage: {

            deps: ['states'],

            get() {
                const dict = hashify( this.get( 'states' )
                    .map( state => state.name ) );

                const props = stageNames.filter( name => dict[name] );
                return props.length > 1
                    ? props.join( ', ' )
                    : props[0] || '';
            },

        },

        status: {

            deps: ['states'],

            get() {
                const dict = hashify( this.get( 'states' )
                    .filter( state => state.field === 'assigned_status_id' ),
                    state => [state.name, state] );

                const props = Object.keys( dict );
                return props.length > 1
                    ? 'INVALID'
                    : dict[props[0]] || '';
            },

        },

        is_template: {

            deps: ['states'],

            get() {
                const props = this.get( 'states' )
                    .filter( state => state.field === 'is_template' );

                return props.length > 1
                    ? ''
                    : props.length 
                        ? 't' === props[0].value || 'true' === props[0].value || true === props[0].value
                        : '';
            },

        },

        others: {

            deps: ['states'],

            get() {
                const dict = hashify( [...ownershipNames, ...stageNames] );
                return this.get( 'states' )
                    .filter( state => state.field != 'assigned_status_id' )
                    .filter( state => state.field != 'restricted' )
                    .filter( state => state.field != 'is_template' )
                    .map( state => state.name )
                    .filter( name => !dict[name] );
            },

        },

    },

} );


// WEBPACK FOOTER //
// ./src/js/model/access/rule.js